import { getCaseInsensitive } from './get-id'
import { FormConfig } from './types'

export const InputElementTypes = ['text', 'number', 'date']

function validateEntityType(i: number, entityType: any): [boolean, string] {
    if (!entityType) return [false, `Form element #${i + 1} must have an "entity" definition`]

    let fields = ['source', 'dataset', 'idField', 'nameField']
    for (let field of fields) {
        if (!entityType[field])
            return [false, `Form element #${i + 1}.entity must have a "${field}" string field`]
    }
    return [true, '']
}

export function validateForm(form: any): [boolean, string] {
    if (!form || form instanceof Array) return [false, 'Form config must be an object']
    if (!form.elements || !(form.elements instanceof Array))
        return [false, 'Form must have "elements" array']
    for (let i = 0; i < form.elements.length; i++) {
        let element = form.elements[i]
        if (!element.type) return [false, `Form element #${i + 1} must have a "type" field`]
        if (InputElementTypes.includes(element.type)) {
            if (!element.field || typeof element.field !== 'string')
                return [false, `Form element #${i + 1} must have a "field" string field`]
            if (element.hasOwnProperty('required') && typeof element.required !== 'boolean')
                return [false, `Form element #${i + 1} "required" field must be a boolean`]
            if (element.hasOwnProperty('readonly') && typeof element.readonly !== 'boolean')
                return [false, `Form element #${i + 1} "readonly" field must be a boolean`]
        } else if (element.type === 'boolean') {
            if (!element.field || typeof element.field !== 'string')
                return [false, `Form element #${i + 1} must have a "field" string field`]
            if (element.hasOwnProperty('readonly') && typeof element.readonly !== 'boolean')
                return [false, `Form element #${i + 1} "readonly" field must be a boolean`]
        } else if (element.type === 'markdown') {
            if (!element.content || typeof element.content !== 'string')
                return [false, `Form element #${i + 1} must have a "content" string field`]
        } else if (element.type === 'markdown-reviewer') {
            if (!element.content || typeof element.content !== 'string')
                return [false, `Form element #${i + 1} must have a "content" string field`]
        } else if (element.type === 'select') {
            if (!element.field || typeof element.field !== 'string')
                return [false, `Form element #${i + 1} must have a "field" string field`]
            if (!element.values || !element.values.length)
                return [
                    false,
                    `Form element #${i + 1} must have a "values" field with list of string`,
                ]
        } else if (element.type === 'entity') {
            if (!element.field || typeof element.field !== 'string')
                return [false, `Form element #${i + 1} must have a "field" string field`]
            let etValidation = validateEntityType(i, element.entity)
            if (!etValidation[0]) return etValidation
            if (element.hasOwnProperty('required') && typeof element.required !== 'boolean')
                return [false, `Form element #${i + 1} "required" field must be a boolean`]
            if (element.hasOwnProperty('readonly') && typeof element.readonly !== 'boolean')
                return [false, `Form element #${i + 1} "readonly" field must be a boolean`]
        } else if (element.type === 'multi-entity') {
            if (!element.label || typeof element.label !== 'string')
                return [false, `Form element #${i + 1} must have a "label" string field`]
            let etValidation = validateEntityType(i, element.entity)
            if (!etValidation[0]) return etValidation
            if (!element.target)
                return [false, `Form element #${i + 1} must have a "target" definition`]
            if (!element.target.table || typeof element.target.table !== 'string')
                return [false, `Form element #${i + 1}.target must have a "table" string field`]
            if (!element.target.objIdField || typeof element.target.objIdField !== 'string')
                return [
                    false,
                    `Form element #${i + 1}.target must have an "objIdField" string field`,
                ]
            if (!element.target.entityIdField || typeof element.target.entityIdField !== 'string')
                return [
                    false,
                    `Form element #${i + 1}.target must have an "entityIdField" string field`,
                ]
        } else if (element.type === 'magic-pointer') {
            if (!element.field || typeof element.field !== 'string')
                return [false, `Form element #${i + 1} must have a "field" string field`]
            if (!element.datasetField || typeof element.datasetField !== 'string')
                return [false, `Form element #${i + 1} must have a "datasetField" string field`]
            if (!(element.entities instanceof Array))
                return [false, `Form element #${i + 1} must have a "entities" array field`]
            for (let entity of element.entities) {
                let validation = validateEntityType(i, entity)
                if (!validation[0]) return validation
            }
            if (element.hasOwnProperty('required') && typeof element.required !== 'boolean')
                return [false, `Form element #${i + 1} "required" field must be a boolean`]
            if (element.hasOwnProperty('readonly') && typeof element.readonly !== 'boolean')
                return [false, `Form element #${i + 1} "readonly" field must be a boolean`]
        } else if (element.type === 'multi-magic-pointer') {
            if (!(element.entities instanceof Array))
                return [false, `Form element #${i + 1} must have a "entities" array field`]
            for (let entity of element.entities) {
                let validation = validateEntityType(i, entity)
                if (!validation[0]) return validation
            }

            if (!element.target)
                return [false, `Form element #${i + 1} must have a "target" definition`]
            if (!element.target.table || typeof element.target.table !== 'string')
                return [false, `Form element #${i + 1}.target must have a "table" string field`]
            if (!element.target.objIdField || typeof element.target.objIdField !== 'string')
                return [
                    false,
                    `Form element #${i + 1}.target must have an "objIdField" string field`,
                ]
            if (!element.target.entityIdField || typeof element.target.entityIdField !== 'string')
                return [
                    false,
                    `Form element #${i + 1}.target must have an "entityIdField" string field`,
                ]
            if (
                !element.target.entityDatasetField ||
                typeof element.target.entityDatasetField !== 'string'
            )
                return [
                    false,
                    `Form element #${i + 1}.target must have an "entityDatasetField" string field`,
                ]
        } else return [false, `Form element #${i + 1} type is invalid`]
    }

    return [true, '']
}

export function isComplete(config: FormConfig, data: any) {
    const validateElementTypes = [...InputElementTypes, 'select']
    for (let element of config.elements) {
        if (validateElementTypes.includes(element.type) && element.required && !getCaseInsensitive(data, element.field!))
            return [false, `Field ${element.field} is required`]
    }

    return [true, '']
}

export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}